"use strict";

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.is-nan");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getStateMedianFamilyIncome;
/* eslint-disable object-curly-newline */

function getStateMedianFamilyIncome(dirtyState, persons) {
  if (!dirtyState) throw new Error('Missing State');
  var state = dirtyState.toUpperCase();
  if (!persons || persons === 0 || Number.isNaN(persons)) throw new Error('Missing Persons Count'); // https://www.justice.gov/ust/eo/bapcpa/20191101/bci_data/median_income_table.htm

  var medianMap = {
    AL: {
      1: 48544,
      2: 56918,
      3: 68554,
      4: 82991
    },
    AK: {
      1: 63997,
      2: 77589,
      3: 102315,
      4: 103055
    },
    AZ: {
      1: 52319,
      2: 65713,
      3: 71704,
      4: 86950
    },
    AR: {
      1: 43230,
      2: 53946,
      3: 58258,
      4: 74086
    },
    CA: {
      1: 60360,
      2: 79271,
      3: 88235,
      4: 101315
    },
    CO: {
      1: 61921,
      2: 81155,
      3: 94193,
      4: 107867
    },
    CT: {
      1: 66689,
      2: 88594,
      3: 101666,
      4: 125714
    },
    DE: {
      1: 55578,
      2: 72644,
      3: 84584,
      4: 102625
    },
    DC: {
      1: 63414,
      2: 115082,
      3: 129777,
      4: 140615
    },
    FL: {
      1: 51559,
      2: 62736,
      3: 68944,
      4: 82560
    },
    GA: {
      1: 50128,
      2: 65007,
      3: 73738,
      4: 87317
    },
    HI: {
      1: 65977,
      2: 77621,
      3: 100620,
      4: 114381
    },
    ID: {
      1: 52117,
      2: 61916,
      3: 67422,
      4: 77923
    },
    IL: {
      1: 54877,
      2: 72593,
      3: 83759,
      4: 103074
    },
    IN: {
      1: 48834,
      2: 62931,
      3: 73537,
      4: 87636
    },
    IA: {
      1: 51579,
      2: 69127,
      3: 78930,
      4: 95581
    },
    KS: {
      1: 51867,
      2: 67221,
      3: 76999,
      4: 88698
    },
    KY: {
      1: 44594,
      2: 56257,
      3: 66732,
      4: 80115
    },
    LA: {
      1: 45634,
      2: 55410,
      3: 63039,
      4: 82282
    },
    ME: {
      1: 51453,
      2: 64889,
      3: 78379,
      4: 95614
    },
    MD: {
      1: 70789,
      2: 90424,
      3: 106282,
      4: 128272
    },
    MA: {
      1: 67119,
      2: 84125,
      3: 108130,
      4: 134418
    },
    MI: {
      1: 53113,
      2: 64428,
      3: 78217,
      4: 93653
    },
    MN: {
      1: 58050,
      2: 77702,
      3: 97657,
      4: 114326
    },
    MS: {
      1: 42414,
      2: 51904,
      3: 58472,
      4: 69732
    },
    MO: {
      1: 49086,
      2: 61519,
      3: 73857,
      4: 92129
    },
    MT: {
      1: 51074,
      2: 64425,
      3: 74919,
      4: 87293
    },
    NE: {
      1: 49680,
      2: 69294,
      3: 78674,
      4: 95445
    },
    NV: {
      1: 52449,
      2: 65756,
      3: 74856,
      4: 81528
    },
    NH: {
      1: 66585,
      2: 80429,
      3: 102095,
      4: 122523
    },
    NJ: {
      1: 69705,
      2: 83739,
      3: 106650,
      4: 131331
    },
    NM: {
      1: 45645,
      2: 56327,
      3: 60617,
      4: 67560
    },
    NY: {
      1: 57137,
      2: 72642,
      3: 88240,
      4: 107550
    },
    NC: {
      1: 48772,
      2: 62050,
      3: 69162,
      4: 87505
    },
    ND: {
      1: 53306,
      2: 80899,
      3: 87824,
      4: 99327
    },
    OH: {
      1: 51297,
      2: 64665,
      3: 77642,
      4: 93239
    },
    OK: {
      1: 49198,
      2: 59495,
      3: 66585,
      4: 76691
    },
    OR: {
      1: 56957,
      2: 71838,
      3: 80698,
      4: 99074
    },
    PA: {
      1: 54605,
      2: 67540,
      3: 83868,
      4: 103316
    },
    RI: {
      1: 61706,
      2: 75858,
      3: 85100,
      4: 104833
    },
    SC: {
      1: 47487,
      2: 61529,
      3: 66595,
      4: 81226
    },
    SD: {
      1: 47906,
      2: 69046,
      3: 70326,
      4: 83823
    },
    TN: {
      1: 48219,
      2: 60913,
      3: 69734,
      4: 79701
    },
    TX: {
      1: 50902,
      2: 66899,
      3: 73948,
      4: 86259
    },
    UT: {
      1: 64806,
      2: 69006,
      3: 82638,
      4: 93474
    },
    VT: {
      1: 57859,
      2: 75602,
      3: 81686,
      4: 103627
    },
    VA: {
      1: 62029,
      2: 79412,
      3: 91995,
      4: 111993
    },
    WA: {
      1: 67511,
      2: 80251,
      3: 92568,
      4: 107481
    },
    WV: {
      1: 49056,
      2: 52028,
      3: 64281,
      4: 76273
    },
    WI: {
      1: 52730,
      2: 68363,
      3: 83607,
      4: 100098
    },
    WY: {
      1: 62090,
      2: 74286,
      3: 78310,
      4: 97862
    },
    // U.S. Territories
    GU: {
      1: 42770,
      2: 51139,
      3: 58275,
      4: 70520
    },
    MP: {
      1: 28722,
      2: 28722,
      3: 33416,
      4: 49148
    },
    PR: {
      1: 24701,
      2: 24701,
      3: 26023,
      4: 34108
    },
    VI: {
      1: 33935,
      2: 40785,
      3: 43486,
      4: 47642
    }
  };
  return medianMap[state][persons > 4 ? 4 : persons] + (persons > 4 ? (persons - 4) * 9000 : 0);
}